// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ScopeSchema = z.enum(['IN_SCOPE','OUT_OF_SCOPE','PENDING','INHERIT'] as const);

export type ScopeType = `${z.infer<typeof ScopeSchema>}`

export default ScopeSchema;
